import { ServiceLogger } from "@/application/services/logger";
import { APP_EVENTS } from "@/domain/app-events";
import { useUpdateUserPreferencesByID } from "../user/user-preferences.mutations";

import { useEffect } from "react";
import { z } from "zod";

const DetailSchema = z.object({
  userExtraPreferences: z.record(z.any()),
  userPreferencesID: z.string().min(1),
});

export function UsePwaInstallationShownListener() {
  const { mutate: updatePreferences } = useUpdateUserPreferencesByID();

  useEffect(() => {
    async function handlePwaInstallationShown(event: Event) {
      ServiceLogger.info(`${APP_EVENTS.PWA_INSTALLATION_SHOWN} event caught`);

      if (event === null || !(event instanceof CustomEvent)) {
        ServiceLogger.error(
          `${APP_EVENTS.PWA_INSTALLATION_SHOWN}: invalid event type`
        );
        return;
      }

      const { data, error } = DetailSchema.safeParse(event.detail);

      if (error || !data) {
        ServiceLogger.error(
          `${APP_EVENTS.PWA_INSTALLATION_SHOWN}: invalid event detail`,
          error
        );
        return;
      }

      updatePreferences(
        {
          ID: data.userPreferencesID,
          preferences: {
            extra: JSON.stringify({
              ...data.userExtraPreferences,
              pwa_installation_shown: true,
            }),
          },
        },
        {
          onError: (error) => {
            ServiceLogger.error(
              `${APP_EVENTS.PWA_INSTALLATION_SHOWN}: failed to update user preferences`,
              error
            );
          },
          onSuccess: () => {
            ServiceLogger.info(
              `${APP_EVENTS.PWA_INSTALLATION_SHOWN}: user preferences updated successfully`
            );
          },
        }
      );
    }

    document.addEventListener(
      APP_EVENTS.PWA_INSTALLATION_SHOWN,
      handlePwaInstallationShown
    );

    return () => {
      document.removeEventListener(
        APP_EVENTS.PWA_INSTALLATION_SHOWN,
        handlePwaInstallationShown
      );
    };
  }, [updatePreferences]);
}
